(function () {
  'use strict';

  var OVELA_CONFIG = window.OVELA_CONFIG || {};
  var PROTECTION_ID = Number(OVELA_CONFIG.protectionId) || 0;
  var PROTECTION_PRICE = Number(OVELA_CONFIG.protectionPrice) || 500;
  /* Oferta de bienvenida: 10% durante 15 min desde que la clienta se suscribe en el popup de Klaviyo.
     Una sola vez por navegador (no se reinicia al recargar ni al abrir otra pestaña). */
  var WELCOME_MS = 15 * 60 * 1000;
  var WELCOME_KEY = 'ovelaWelcomeDeadline';
  var WELCOME_CODE = 'OVELA10';
  /* Campaña actual: pop-up de Klaviyo y etiqueta de precio, en snippets/ovela-campaign-bar.liquid */
  var CAMPAIGN = window.OVELA_CAMPAIGN || {};
  var POPUP_ID = CAMPAIGN.popupId || 'V2HXR7';
  /* Etiqueta bajo el precio de cada prenda del carrito */
  var HALLOWEEN_LABEL = CAMPAIGN.priceLabel || 'Precio especial';

  function welcomeDeadline() {
    try {
      return Number(localStorage.getItem(WELCOME_KEY)) || 0;
    } catch (e) {
      return 0;
    }
  }

  function welcomeActive() {
    return welcomeDeadline() > Date.now();
  }

  function $(id) {
    return document.getElementById(id);
  }

  function money(cents) {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(Number(cents || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[m];
    });
  }

  function storeGet(key) {
    try {
      return sessionStorage.getItem(key) || '';
    } catch (e) {
      return '';
    }
  }

  function storeSet(key, value) {
    try {
      if (value) {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.removeItem(key);
      }
    } catch (e) {}
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Solicitud no completada');
      return response.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('No se pudo cargar el carrito');
      return response.json();
    });
  }

  /* =====================================================
     MENÚ DESPLEGABLE DE ESCRITORIO
     ===================================================== */

  function closeMegaItems() {
    document.querySelectorAll('.ovela-header-nav-item.has-mega.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var toggle = item.querySelector('[data-mega-toggle]');
      if (toggle) {
        toggle.classList.remove('menu-active');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initMegaMenu() {
    var megaItems = document.querySelectorAll('.ovela-header-nav-item.has-mega');

    megaItems.forEach(function (item) {
      var toggle = item.querySelector('[data-mega-toggle]');
      if (!toggle || toggle.dataset.ovelaBound === 'true') return;
      toggle.dataset.ovelaBound = 'true';

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var wasOpen = item.classList.contains('is-open');
        closeMegaItems();
        if (!wasOpen) {
          item.classList.add('is-open');
          toggle.classList.add('menu-active');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    if (!document.documentElement.dataset.ovelaMegaOutsideBound) {
      document.documentElement.dataset.ovelaMegaOutsideBound = 'true';
      document.addEventListener('click', function (event) {
        if (event.target.closest('.ovela-header-nav-item.has-mega')) return;
        closeMegaItems();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeMegaItems();
      });
    }
  }

  /* =====================================================
     PERFIL Y MENÚ MÓVIL
     ===================================================== */

  function initProfile() {
    var open = $('ovelaProfileOpen');
    var close = $('ovelaProfileClose');
    var overlay = $('ovelaProfileOverlay');

    if (open && overlay && open.dataset.ovelaBound !== 'true') {
      open.dataset.ovelaBound = 'true';
      open.addEventListener('click', function () { overlay.classList.add('is-open'); });
    }
    if (close && overlay && close.dataset.ovelaBound !== 'true') {
      close.dataset.ovelaBound = 'true';
      close.addEventListener('click', function () { overlay.classList.remove('is-open'); });
    }
    if (overlay && overlay.dataset.ovelaBound !== 'true') {
      overlay.dataset.ovelaBound = 'true';
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) overlay.classList.remove('is-open');
      });
    }
  }

  function initMobileMenu() {
    var open = $('ovelaMobileOpen');
    var close = $('ovelaMobileClose');
    var drawer = $('ovelaMobileDrawer');

    if (open && drawer && open.dataset.ovelaBound !== 'true') {
      open.dataset.ovelaBound = 'true';
      open.addEventListener('click', function () {
        drawer.classList.add('is-open');
        document.body.classList.add('ovela-menu-open');
      });
    }
    if (close && drawer && close.dataset.ovelaBound !== 'true') {
      close.dataset.ovelaBound = 'true';
      close.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        document.body.classList.remove('ovela-menu-open');
      });
    }

    document.querySelectorAll('.ovela-mobile-accordion').forEach(function (accordion) {
      var button = accordion.querySelector('.ovela-mobile-accordion-button');
      if (!button || button.dataset.ovelaBound === 'true') return;
      button.dataset.ovelaBound = 'true';
      button.addEventListener('click', function () {
        var wasOpen = accordion.classList.contains('is-open');
        document.querySelectorAll('.ovela-mobile-accordion').forEach(function (other) {
          other.classList.remove('is-open');
        });
        if (!wasOpen) accordion.classList.add('is-open');
      });
    });

    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (link) {
        if (link.dataset.ovelaBound === 'true') return;
        link.dataset.ovelaBound = 'true';
        link.addEventListener('click', function () {
          drawer.classList.remove('is-open');
          document.body.classList.remove('ovela-menu-open');
        });
      });
    }
  }

  /* =====================================================
     CARRITO AJAX
     ===================================================== */

  function initCart() {
    var overlay = $('ovelaCartOverlay');
    var open = $('ovelaCartOpen');
    var mobileOpen = $('ovelaMobileCartOpen');
    var close = $('ovelaCartClose');
    var items = $('ovelaCartItems');
    var grid = $('ovelaRecoGrid');
    var message = $('ovelaDiscountMessage');
    var bar = $('ovelaDiscountBar');
    var count = $('ovelaCartCountText');
    var countWord = $('ovelaCartCountWord');
    var desktopCount = $('ovelaDesktopCount');
    var mobileCount = $('ovelaMobileCount');
    var extras = $('ovelaExtras');
    var protectBox = $('ovelaProtect');
    var protectSwitch = $('ovelaProtectSwitch');
    var protectPrice = $('ovelaProtectPrice');
    var feeRow = $('ovelaFeeRow');
    var feeValue = $('ovelaFeeValue');
    var checkout = $('ovelaCheckout');
    var checkoutTotal = $('ovelaCheckoutTotal');
    var codeToggle = $('ovelaCodeToggle');
    var codeBody = $('ovelaCodeBody');
    var codeInput = $('ovelaCodeInput');
    var codeApply = $('ovelaCodeApply');
    var codeMsg = $('ovelaCodeMsg');
    var codeChip = $('ovelaCodeChip');
    var codeName = $('ovelaCodeName');
    var codeStatus = $('ovelaCodeStatus');
    var codeRemove = $('ovelaCodeRemove');

    /* Si el HTML del carrito no existe, el menú sigue funcionando. */
    if (!overlay || !items || !grid) return;
    if (overlay.dataset.ovelaCartInitialized === 'true') return;
    overlay.dataset.ovelaCartInitialized = 'true';

    function split(cart) {
      var products = [];
      var protection = null;
      var quantity = 0;

      (cart.items || []).forEach(function (item) {
        if (PROTECTION_ID && Number(item.variant_id) === PROTECTION_ID) {
          protection = item;
        } else {
          products.push(item);
          quantity += Number(item.quantity || 0);
        }
      });

      return { products: products, protect: protection, count: quantity };
    }

    function updateBadges(quantity) {
      if (count) count.textContent = quantity;
      if (countWord) countWord.textContent = quantity === 1 ? 'artículo' : 'artículos';

      [desktopCount, mobileCount].forEach(function (element) {
        if (!element) return;
        element.textContent = quantity;
        element.style.display = quantity ? '' : 'none';
      });
    }

    /* Barra de descuentos: las marcas de 2, 3 y 4+ artículos están en 33%, 66% y 100%.
       Con 1 artículo la barra se queda a mitad de camino de la primera marca. */
    function discountUI(quantity) {
      document.querySelectorAll('.ovela-discount-level, .ovela-discount-tick').forEach(function (element) {
        element.classList.toggle('active', quantity >= Number(element.dataset.level));
      });

      var percent = quantity >= 4 ? 100 :
        quantity === 3 ? 66.666 :
        quantity === 2 ? 33.333 :
        quantity === 1 ? 15 : 0;

      if (bar) bar.style.width = percent + '%';
      if (!message) return;

      if (quantity >= 4) {
        message.textContent = '¡Perfecto! Ya tienes un 20% de descuento en tu pedido.';
      } else if (quantity >= 3) {
        message.textContent = '¡Genial! Ya tienes un 15%. Añade 1 producto más para conseguir un 20%.';
      } else if (quantity >= 2) {
        message.textContent = '¡Genial! Ya tienes un 10%. Añade 1 producto más para conseguir un 15%.';
      } else if (quantity === 1) {
        message.textContent = 'Añade 1 producto más y consigue un 10% de descuento.';
      } else {
        message.textContent = 'Añade 2 productos y consigue un 10% de descuento.';
      }
    }

    function getCompareAtPrices(cart) {
      var requests = [];
      var compareMap = {};
      var seen = {};

      (cart.items || []).forEach(function (item) {
        if (!item.url) return;
        var url = item.url.split('?')[0];
        if (seen[url]) return;
        seen[url] = true;

        requests.push(
          fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (response) {
              if (!response.ok) throw new Error('No se pudo cargar el producto');
              return response.json();
            })
            .then(function (product) {
              if (!product || !product.variants) return;
              product.variants.forEach(function (variant) {
                if (variant.compare_at_price && Number(variant.compare_at_price) > 0) {
                  compareMap[String(variant.id)] = Number(variant.compare_at_price);
                }
              });
            })
            .catch(function () {})
        );
      });

      return Promise.all(requests).then(function () {
        return compareMap;
      });
    }

    function codeApplied(cart, code) {
      var expected = String(code).toLowerCase();
      var found = false;

      (cart.cart_level_discount_applications || []).forEach(function (discount) {
        if (discount.type === 'discount_code' && String(discount.title).toLowerCase() === expected) found = true;
      });

      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (allocation) {
          var discount = allocation.discount_application || {};
          if (discount.type === 'discount_code' && String(discount.title).toLowerCase() === expected) found = true;
        });
      });

      return found;
    }

    function setCodeMsg(text) {
      if (codeMsg) codeMsg.textContent = text || '';
    }

    function renderCode(cart) {
      if (!codeToggle || !codeBody || !codeChip) return;
      var code = storeGet('ovelaDiscountCode');

      if (code) {
        /* El código aplicado se muestra encima de "Finalizar compra" (renderApplied) */
        codeToggle.hidden = true;
        codeBody.hidden = true;
        codeChip.hidden = true;
      } else {
        codeChip.hidden = true;
        codeToggle.hidden = false;
      }
    }

    function applyCode() {
      if (!codeInput || !codeApply) return;
      var code = codeInput.value.trim();

      if (!code) {
        setCodeMsg('Escribe tu código de descuento.');
        return;
      }

      codeApply.disabled = true;
      setCodeMsg('');

      post('/cart/update.js', { discount: code })
        .then(function () {
          storeSet('ovelaDiscountCode', code.toUpperCase());
          codeInput.value = '';
          return getCart();
        })
        .then(renderCart)
        .catch(function () {
          setCodeMsg('No hemos podido aplicar el código. Inténtalo de nuevo.');
        })
        .then(function () {
          codeApply.disabled = false;
        });
    }

    function removeCode() {
      storeSet('ovelaDiscountCode', '');
      setCodeMsg('');
      post('/cart/update.js', { discount: '' })
        .catch(function () {})
        .then(getCart)
        .then(renderCart)
        .catch(function () {});
    }

    /* Descuentos aplicados, justo encima del botón "Finalizar compra" */
    function renderApplied(cart, hasProducts) {
      var list = $('ovelaApplied');
      if (!list) return;

      var totals = {};
      var order = [];

      function add(title, amount, isCode) {
        var key = String(title || '').toUpperCase();
        if (!key) return;
        if (!totals[key]) {
          totals[key] = { title: title, amount: 0, isCode: isCode };
          order.push(key);
        }
        totals[key].amount += Number(amount || 0);
      }

      (cart.cart_level_discount_applications || []).forEach(function (d) {
        add(d.title, d.total_allocated_amount, d.type === 'discount_code');
      });

      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (a) {
          var d = a.discount_application || {};
          add(d.title, a.amount, d.type === 'discount_code');
        });
      });

      /* Códigos que Shopify no ha podido aplicar (p. ej. no acumulables con el descuento por cantidad) */
      var blocked = {};
      (cart.discount_codes || []).forEach(function (dc) {
        if (dc && dc.code && dc.applicable === false) blocked[String(dc.code).toUpperCase()] = true;
      });

      var code = storeGet('ovelaDiscountCode');
      if (code && !totals[code.toUpperCase()]) {
        totals[code.toUpperCase()] = {
          title: code,
          amount: 0,
          isCode: true,
          pending: !blocked[code.toUpperCase()],
          blocked: !!blocked[code.toUpperCase()]
        };
        order.push(code.toUpperCase());
      }

      if (!hasProducts || !order.length) {
        list.hidden = true;
        list.innerHTML = '';
        return;
      }

      list.innerHTML = order.map(function (key) {
        var d = totals[key];
        var isWelcome = key === WELCOME_CODE;
        var label = isWelcome ? 'Descuento de bienvenida 10%' : (d.isCode ? d.title : 'Descuento por cantidad');
        var value = d.blocked
          ? '<span class="ovela-applied-pending">no acumulable con tu descuento actual</span>'
          : d.pending
            ? '<span class="ovela-applied-pending">se aplica al pagar</span>'
            : '<strong>−' + money(d.amount) + '</strong>';
        return (
          '<li class="ovela-applied-item' + (d.blocked ? ' is-blocked' : '') + '">' +
            '<span class="ovela-applied-name"><i aria-hidden="true">✓</i>' + escapeHtml(label) +
              (d.isCode ? ' <small>' + escapeHtml(d.title) + '</small>' : '') +
            '</span>' +
            '<span class="ovela-applied-value">' + value +
              (d.isCode ? '<button type="button" class="ovela-applied-remove" data-remove-code aria-label="Quitar código ' + escapeHtml(d.title) + '">×</button>' : '') +
            '</span>' +
          '</li>'
        );
      }).join('');
      list.hidden = false;
    }

    function renderCart(cart) {
      if (!cart || !cart.items) return Promise.resolve();

      var state = split(cart);

      if (state.protect && !state.products.length) {
        return post('/cart/change.js', { id: state.protect.key, quantity: 0 }).then(getCart).then(renderCart);
      }

      updateBadges(state.count);
      discountUI(state.count);

      window.ovelaEligible = state.count;
      window.ovelaEligibleTotal = state.products.reduce(function (sum, item) {
        return sum + Number(item.final_line_price || 0);
      }, 0);
      updateOfferTimer();

      if (checkoutTotal) {
        checkoutTotal.textContent = state.products.length ? '· ' + money(cart.total_price) : '';
      }

      if (protectBox) {
        protectBox.hidden = !PROTECTION_ID;
        if (PROTECTION_ID && protectPrice) protectPrice.textContent = money(PROTECTION_PRICE);
        if (protectSwitch && PROTECTION_ID) {
          protectSwitch.setAttribute('aria-checked', state.protect ? 'true' : 'false');
        }
      }

      if (extras) extras.hidden = !state.products.length;

      if (state.protect && feeValue && feeRow) {
        feeValue.textContent = '+' + money(state.protect.final_line_price);
        feeRow.hidden = false;
      } else if (feeRow) {
        feeRow.hidden = true;
      }

      renderCode(cart);
      renderApplied(cart, state.products.length > 0);

      var savingsRow = $('ovelaCartSavings');
      var savingsValue = $('ovelaCartSavingsValue');
      if (savingsRow) savingsRow.hidden = true;

      if (!state.products.length) {
        items.innerHTML =
          '<div class="ovela-cart-empty">' +
            '<h2 class="ovela-cart-empty-title">Tu carrito está vacío</h2>' +
            '<p class="ovela-cart-empty-text">Descubre nuestras prendas y encuentra tu próximo look.</p>' +
          '</div>';
        return Promise.resolve();
      }

      var stamp = Date.now();
      window.ovelaCartRenderStamp = stamp;

      return getCompareAtPrices(cart).then(function (compareMap) {
        if (window.ovelaCartRenderStamp !== stamp) return;

        var original = 0;
        var actualProducts = 0;

        state.products.forEach(function (item) {
          var compare = Number(compareMap[String(item.variant_id)] || 0);
          var base = Number(item.original_price || item.price || 0);
          original += Math.max(compare, base) * Number(item.quantity || 0);
          actualProducts += Number(item.final_line_price || 0);
        });

        var saving = Math.max(0, original - actualProducts);

        if (saving > 0 && savingsValue && savingsRow) {
          savingsValue.textContent = 'AHORRAS ' + money(saving);
          savingsRow.hidden = false;
        }

        items.innerHTML = '<div class="ovela-cart-items">' +
          state.products.map(function (item) {
            var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
            var current = Number(item.final_price);
            var compare = Number(compareMap[String(item.variant_id)] || 0);
            var hasCompare = compare > current;
            var percent = hasCompare ? Math.round((1 - current / compare) * 100) : 0;

            var price =
              '<p class="ovela-cart-item-price">' +
                '<span class="ovela-cart-item-price-current">' + money(current) + '</span>' +
                (hasCompare
                  ? '<span class="ovela-cart-item-price-compare">' + money(compare) + '</span>' +
                    '<span class="ovela-price-badge">-' + percent + '%</span>'
                  : '') +
              '</p>' +
              (hasCompare ? '<p class="ovela-hw-label">' + HALLOWEEN_LABEL + '</p>' : '');

            return (
              '<div class="ovela-cart-item">' +
                '<img class="ovela-cart-item-image" src="' + escapeHtml(item.image || '') + '" alt="' + escapeHtml(item.product_title) + '">' +
                '<div class="ovela-cart-item-info">' +
                  '<p class="ovela-cart-item-title">' + escapeHtml(item.product_title) + '</p>' +
                  (variant ? '<p class="ovela-cart-item-variant">' + escapeHtml(variant) + '</p>' : '') +
                  price +
                  '<div class="ovela-item-actions">' +
                    '<div class="ovela-qty">' +
                      '<button type="button" data-change data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Quitar una unidad">−</button>' +
                      '<span>' + item.quantity + '</span>' +
                      '<button type="button" data-change data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Añadir una unidad">+</button>' +
                    '</div>' +
                    '<button type="button" class="ovela-remove" data-change data-key="' + escapeHtml(item.key) + '" data-qty="0">Eliminar</button>' +
                  '</div>' +
                '</div>' +
              '</div>'
            );
          }).join('') +
        '</div>';
      });
    }

    function updateQty(key, quantity) {
      return post('/cart/change.js', { id: key, quantity: quantity }).then(getCart).then(renderCart);
    }

    function addProduct(id) {
      return post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }).then(getCart).then(renderCart);
    }

    function randomRecommendations() {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-reco-card]'));
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = cards[i];
        cards[i] = cards[j];
        cards[j] = temp;
      }
      grid.innerHTML = '';
      cards.slice(0, 6).forEach(function (card) {
        grid.appendChild(card);
      });
    }

    var timerInterval = null;

    function isSubscribed() {
      if (welcomeDeadline()) return true;
      try {
        return localStorage.getItem('ovela_lista_negra_subscribed') === '1' || localStorage.getItem('ovela_halloween_subscribed') === '1';
      } catch (e) {
        return false;
      }
    }

    /* Cuenta atrás fija para todas: termina a medianoche. */
    function updateOfferTimer() {
      var box = $('ovelaOfferTimer');
      var clock = $('ovelaOfferClock');
      var note = $('ovelaOfferNote');
      if (!box || !clock) return;

      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      var left = Math.max(0, Math.floor((end - now) / 1000));
      clock.textContent =
        String(Math.floor(left / 3600)).padStart(2, '0') + ':' +
        String(Math.floor((left % 3600) / 60)).padStart(2, '0') + ':' +
        String(left % 60).padStart(2, '0');

      box.hidden = !(window.ovelaEligible >= 1);
      if (note) note.classList.toggle('is-cta', !isSubscribed());
    }

    function startOfferTimer() {
      updateOfferTimer();
      if (!timerInterval) timerInterval = setInterval(updateOfferTimer, 1000);
    }

    /* Al suscribirse en el pop-up: el 10% de bienvenida se aplica solo al carrito */
    function startWelcomeOffer() {
      try {
        if (!welcomeDeadline()) localStorage.setItem(WELCOME_KEY, String(Date.now() + WELCOME_MS));
      } catch (e) {}
      storeSet('ovelaDiscountCode', WELCOME_CODE);
      post('/cart/update.js', { discount: WELCOME_CODE })
        .catch(function () {})
        .then(getCart)
        .then(renderCart)
        .catch(function () {});
      updateOfferTimer();
    }

    var offerNote = $('ovelaOfferNote');
    if (offerNote) {
      offerNote.addEventListener('click', function () {
        if (isSubscribed()) return;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', POPUP_ID]);
      });
    }

    window.addEventListener('klaviyoForms', function (event) {
      var type = event && event.detail && event.detail.type;
      if (type === 'submit' || type === 'submitSuccess') startWelcomeOffer();
    });

    function openCart() {
      startOfferTimer();
      randomRecommendations();
      getCart().then(renderCart).catch(function () {});
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    [open, mobileOpen].forEach(function (button) {
      if (!button || button.dataset.ovelaBound === 'true') return;
      button.dataset.ovelaBound = 'true';
      button.addEventListener('click', openCart);
    });

    if (close) close.addEventListener('click', closeCart);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeCart();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeCart();
    });

    items.addEventListener('click', function (event) {
      var button = event.target.closest('[data-change]');
      if (!button) return;
      button.disabled = true;
      updateQty(button.dataset.key, Number(button.dataset.qty))
        .catch(function () {})
        .then(function () {
          button.disabled = false;
        });
    });

    grid.addEventListener('click', function (event) {
      var button = event.target.closest('[data-add]');
      if (!button) return;
      button.disabled = true;
      button.textContent = 'AÑADIENDO...';
      addProduct(button.dataset.add)
        .catch(function () {})
        .then(function () {
          button.disabled = false;
          button.textContent = 'AÑADIR';
        });
    });

    if (protectSwitch) {
      protectSwitch.addEventListener('click', function () {
        if (protectSwitch.disabled || !PROTECTION_ID) return;
        var turnOn = protectSwitch.getAttribute('aria-checked') !== 'true';
        protectSwitch.setAttribute('aria-checked', turnOn ? 'true' : 'false');
        protectSwitch.disabled = true;

        getCart()
          .then(function (cart) {
            var state = split(cart);
            if (turnOn && !state.protect) {
              return post('/cart/add.js', { items: [{ id: PROTECTION_ID, quantity: 1 }] }).then(getCart);
            }
            if (!turnOn && state.protect) {
              return post('/cart/change.js', { id: state.protect.key, quantity: 0 }).then(getCart);
            }
            return cart;
          })
          .then(renderCart)
          .catch(function () {})
          .then(function () {
            protectSwitch.disabled = false;
          });
      });
    }

    if (codeToggle && codeBody) {
      codeToggle.addEventListener('click', function () {
        var willOpen = codeBody.hidden;
        codeBody.hidden = !willOpen;
        codeToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen && codeInput) {
          setTimeout(function () { codeInput.focus(); }, 50);
        }
      });
    }

    if (codeApply) codeApply.addEventListener('click', applyCode);

    if (codeInput) {
      codeInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyCode();
        }
      });
    }

    if (codeRemove) codeRemove.addEventListener('click', removeCode);

    var appliedList = $('ovelaApplied');
    if (appliedList) {
      appliedList.addEventListener('click', function (event) {
        if (event.target.closest('[data-remove-code]')) removeCode();
      });
    }

    if (checkout) {
      checkout.addEventListener('click', function (event) {
        var code = storeGet('ovelaDiscountCode');
        if (code) {
          event.preventDefault();
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
        }
      });
    }

    getCart().then(function (cart) {
      var state = split(cart);
      updateBadges(state.count);
      discountUI(state.count);
    }).catch(function () {});
  }

  /* =====================================================
     INICIALIZACIÓN
     ===================================================== */

  function initOvela() {
    initMegaMenu();
    initProfile();
    initMobileMenu();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOvela);
  } else {
    initOvela();
  }
})();
